import { Vector3 } from '@technology/web3d';
import { Point2D, Point3D } from './point.types';
import { DeepNullable } from 'ts-essentials/dist/deep-nullable';

export const point2DToVector3 = (point: Point2D, z = 0): Vector3 =>
  new Vector3(point.x, point.y, z);

export const point3DToVector3 = (point: Point3D): Vector3 =>
  new Vector3(point.x, point.y, point.z);

export const vector3ToPoint2D = (vector: Vector3): Point2D => ({
  x: vector.x,
  y: vector.y,
});

export const vector3ToPoint3D = (vector: Vector3): Point3D => ({
  x: vector.x,
  y: vector.y,
  z: vector.z,
});

export const point2DToPoint3D = (point: Point2D, z = 0): Point3D => ({
  x: point.x,
  y: point.y,
  z,
});

export const point3DToPoint2D = (point: Point3D): Point2D => ({
  x: point.x,
  y: point.y,
});

export const partialPointToVector3 = (
  point: DeepNullable<Partial<Point3D>> | DeepNullable<Partial<Point2D>>
): Vector3 => {
  if ('z' in point && point.z !== undefined) {
    return point3DToVector3({
      x: point.x ?? 0,
      y: point.y ?? 0,
      z: point.z ?? 0,
    });
  }
  return point2DToVector3({ x: point.x ?? 0, y: point.y ?? 0 });
};
